import { render } from "./AppointmentsCalendarView.vue?vue&type=template&id=0c6d538c"
import script from "./AppointmentsCalendarView.vue?vue&type=script&lang=js"
export * from "./AppointmentsCalendarView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__